module.exports = __webpack_public_path__ + "static/media/handlebars.df5fc40b.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/Portfolio/images/platforms/handlebars.png
 ** module id = 225
 ** module chunks = 0
 **/